<template>
  <div class="ranking-follow-content">
    <div class="ranking-follow-header">
      <img
        class="ranking-follow-header-img"
        width="100%" :src="dataInfo.rank_pic?dataInfo.rank_pic:require('../../assets/ranking/top-follow@3x.png')"/>
        <!-- :src="dataInfo.rank_pic?dataInfo.rank_pic:require('../../assets/ranking/top-follow@3x.png')" -->
    </div>
    <div class="ranking-follow-doctor">
      <follow-doctor-list
        @handleItem="handleItem"
        class="ranking-follow-doctor-list"
        :dataList="dataList"
      />
      <div style="height:22px"></div>
    </div>
  </div>
</template>
<script>
import { getRankingDoctorList } from "../../api/rankingApi.js";
import FollowDoctorList from "../../components/ranking/FollowDoctorList.vue";
export default {
  components: { FollowDoctorList },
  data() {
    return {
      tempDataParams: {},
      formClient: "",
      dataList: [],
      dataInfo:{rank_pic:""}
    };
  },
  mounted() {
    this.tempDataParams = this.$route.query;
    this.formClient = this.$route.query.formClient || "";
    this.getDoctorsList();
    document.body.style.backgroundColor = "#FFE7DC";
    this.$nextTick(() => {
      document.addEventListener("UniAppJSBridgeReady", function() {});
    });
  },
  methods: {
    getDoctorsList() {
      const self = this;
      this.tempDataParams["page"] = this.curPage;
      this.tempDataParams["pageNum"] = 10;
      getRankingDoctorList(this.tempDataParams).then((res) => {
        self.dataList = res.data.dataList || [];
        self.dataInfo = res.data.dataInfo || {rank_pic:""};
        document.title = self.dataInfo.title;
      });
    },
    handleItem(item) {
      if (this.formClient == "bjAndroid") {
        try {
          $App.getDataFormVue(item.doc_id_dt);
        } catch (e) {
          window.webkit.messageHandlers.doctor.postMessage({
            docid: item.doc_id_dt,
          });
        }
        return;
      } else if (this.formClient == "bjIOS") {
        window.webkit.messageHandlers.doctor.postMessage({
          docid: item.doc_id_dt,
        });
        return;
      }else if(this.formClient == "h5"){
         let url = this.FEServer+"doctor/details?doc_id="+item.doc_id +"&order_source=rank_" + this.tempDataParams.rank_id;
          // window.location.replace(url) 
          uni.navigateTo({
            url:
              "../doctor/details?doc_id="+item.doc_id +"&order_source=rank_" + this.tempDataParams.rank_id
          });
          return
      } else if (this.formClient == "harmony") {
        const msg = JSON.stringify({
          action: "goDetail",
          data: {
            doc_id: item.doc_id,
            order_source: "rank_" + this.tempDataParams.rank_id,
          },
        });
        // 方式1：使用 postMessage（推荐）
        window.jsBridge.postMessage(msg);
        return;
      }
      this.$nextTick(() => {
        // document.addEventListener('UniAppJSBridgeReady', function() {
        // 向 app 发送消息
        uni.postMessage({
          data: {
            action: "doctorDetails",
            url:
              "../doctor/details?doc_id=" +
              item.doc_id +
              "&order_source=rank_" +
              this.tempDataParams.rank_id,
          },
        });
        if (this.tempDataParams.formClient == "wechat") {
          uni.navigateTo({
            url: "../doctor/details?doc_id=" +item.doc_id +"&order_source=rank_" +this.tempDataParams.rank_id,
          });
        }
      });
      // })
    },
  },
  beforeCreate() {
    document.title = this.$route.meta.title;
  },
};
</script>
<style lang="scss" scoped>
.ranking-follow {
  &-header {
    width: 100%;
    height: 445px;
    &-img {
      width: 100%;
      height: 445px;
    }
  }
  &-doctor {
    margin: 0 20px;
    margin-top: 16px;
    &-list {
    }
  }
  &-content {
  }
}
</style>
